export default "__VITE_ASSET__DJXBDIbK__"